import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { MaskLines } from "../components/Reveal";

export default function NotFound() {
  return (
    <main data-testid="404-page" className="bg-black pt-32 md:pt-40 min-h-screen flex items-center">
      <section className="max-w-[1600px] mx-auto px-6 md:px-10 py-24 w-full">
        <p className="text-[10px] uppercase tracking-overline text-[color:var(--dk-gold)] mb-6">404 · Off Screen</p>
        <h1 className="font-serif-display font-light text-white text-[20vw] md:text-[15vw] leading-[0.85] tracking-tighter">
          <MaskLines lines={["Cut."]} />
        </h1>
        <p className="mt-8 max-w-xl font-serif-display italic text-white/60 text-xl md:text-2xl">
          The scene you were looking for isn&apos;t in the reel. Let&apos;s find you a better take.
        </p>
        <Link to="/" data-testid="404-home-link"
          className="mt-10 inline-flex items-center gap-3 text-white eyebrow-link">
          <ArrowLeft size={16} /> Return home
        </Link>
      </section>
    </main>
  );
}
